var dnJsLazyload = function() {
    new LazyLoad({
        elements_selector: ".dn-img-lazy, .dnJs-imgLazy",
        threshold: 200,
    });
};

jQuery(document).ready(function($) {
    dnJsLazyload();
});
